import {
  DASHBOARD_DefaultParams,
  DASHBOARD_SearchParams,
} from "./dashboard.interface";

const PREFIX = "DASHBOARD";

export class GET_LOV {
  public static readonly type = `[DASHBOARD] GET LOV`;
  constructor(
    public readonly productCode: string,
    public readonly userId: string,
  ) {}
}

export class GET_UNIFIED_LOV {
  public static readonly type = `[DASHBOARD] GET UNIFIED LOV`;
  constructor(public readonly userId: string) {}
}

export class GET_POSTCODE_INFO {
  public static readonly type = `[DASHBOARD] GET POSTCODE INFO`;
  constructor(public readonly payload: string) {}
}
export class GET_PRODUCT {
  public static readonly type = `[DASHBOARD] GET LOV`;
  constructor(public readonly productCode: string) {}
}

export class GET_DEFAULT_LIST {
  public static readonly type = `[${PREFIX}] GET DEFAULT LIST`;
  constructor(public readonly payload: DASHBOARD_DefaultParams) {}
}

export class GET_DEFAULT_MT_APPROVAL_LIST {
  public static readonly type = `[${PREFIX}] GET DEFAULT MT APPROVAL LIST`;
  constructor(public readonly payload: DASHBOARD_DefaultParams) {}
}

export class SET_SUMMARY_FILTER_CRITERIA {
  public static readonly type = `[${PREFIX}] GET SUMMARY FILTER CRITERIA`;
  constructor(public readonly payload) {}
}

export class SET_DRAFT_FILTER_CRITERIA {
  public static readonly type = `[${PREFIX}] GET DRAFT FILTER CRITERIA`;
  constructor(public readonly payload) {}
}

export class SET_EXPIRING_FILTER_CRITERIA {
  public static readonly type = `[${PREFIX}] GET EXPIRING FILTER CRITERIA`;
  constructor(public readonly payload) {}
}

export class SET_PRODUCT {
  public static readonly type = `[DASHBOARD] SET PRODUCT`;
  constructor(public readonly product: string) {}
}

export class GET_SUMMARY_SEARCH_LIST {
  public static readonly type = `[${PREFIX}] GET SUMMARY SEARCH LIST`;
  constructor(public readonly payload: DASHBOARD_SearchParams) {}
}

export class GET_DRAFT_SEARCH_LIST {
  public static readonly type = `[${PREFIX}] GET DRAFTS SEARCH LIST`;
  constructor(public readonly payload: DASHBOARD_SearchParams) {}
}

export class GET_EXPIRING_SEARCH_LIST {
  public static readonly type = `[${PREFIX}] GET EXPIRING SEARCH LIST`;
  constructor(public readonly payload: DASHBOARD_SearchParams) {}
}

export class GET_DRAFT_DETAIL {
  public static readonly type = `[${PREFIX}] GET DRAFT DETAIL`;
  constructor(public readonly payload) {}
}

export class GET_SUBMENU_REDIRECTURL {
  public static readonly type = `[${PREFIX}] GET SUBMENU REDIRECTURL`;
  constructor(public readonly payload) {}
}

export class GET_POLICY_ENQUIRY_LIST {
  public static readonly type = `[${PREFIX}] GET POLICY ENQUIRY LIST`;
  constructor(public readonly payload) {}
}

export class PAGER_SELECTION_SETTER {
  public static readonly type = `[${PREFIX}] PAGER SELECTION SETTER`;
  constructor(public readonly payload) {}
}

export class MAIN_PRODUCT_TYPE {
  public static readonly type = `[${PREFIX}] MAIN PRODUCT TYPE`;
  constructor(public readonly payload) {}
}

export class PROMPT_ERROR {
  public static readonly type = `[${PREFIX}] PROMPT ERROR`;
  constructor(public readonly payload) {}
}
export class RESET_PROMPT_ERROR {
  public static readonly type = `[${PREFIX}] RESET PROMPT ERROR`;
}

export class GET_REDIRECT_PAGE {
  public static readonly type = `[${PREFIX}] GET REDIRECT PAGE`;
  constructor(public readonly payload) {}
}

export class REDIRECT_TO_SAT_MOTOR {
  public static readonly type = `[${PREFIX}] REDIRECT TO SAT MOTOR`;
  constructor(public readonly payload) {}
}

export class GET_PENDING_APPROVAL_SEARCH_LIST {
  public static readonly type = `[${PREFIX}] GET PENDING APPROVAL SEARCH LIST`;
  constructor(public readonly payload: DASHBOARD_SearchParams) {}
}

export class SET_PENDING_APPROVAL_FILTER_CRITERIA {
  public static readonly type = `[${PREFIX}] SET PENDING APPROVAL FILTER CRITERIA`;
  constructor(public readonly payload) {}
}

export class GET_MOTOR_APPROVAL_SEARCH_LIST {
  public static readonly type = `[${PREFIX}] GET MOTOR APPROVAL SEARCH LIST`;
  constructor(public readonly payload: DASHBOARD_SearchParams) {}
}

export class SET_MOTOR_APPROVAL_FILTER_CRITERIA {
  public static readonly type = `[${PREFIX}] SET MOTOR APPROVAL FILTER CRITERIA`;
  constructor(public readonly payload) {}
}

export class GET_EQUOTE_PRODUCT_ACCESS {
  public static readonly type = `[${PREFIX}] GET EQUOTE PRODUCT ACCESS`;
  constructor(public readonly payload) {}
}

export class STORE_DASHBOARD_TAB {
  public static readonly type = `[${PREFIX}] STORE DASHBOARD TAB`;
  constructor(public readonly payload) {}
}

export class CLEAR_DASHBOARD_TAB {
  public static readonly type = `[${PREFIX}] CLEAR DASHBOARD TAB`;
}

export class GET_DOCUMENT_LOV {
  public static readonly type = `[${PREFIX}] GET DOCUMENT LOV`;
  constructor(public readonly payload) {}
}

export class GET_DOCUMENTS {
  public static readonly type = `[${PREFIX}] GET DOCUMENTS`;
  constructor(public readonly payload) {}
}

export class GET_REQUOTE_DOCUMENTS {
  public static readonly type = `[${PREFIX}] GET REQOUTE DOCUMENTS`;
  constructor(public readonly payload) {}
}

export class DOWNLOAD_DOCUMENT {
  public static readonly type = `[${PREFIX}] DOWNLOAD DOCUMENT`;
  constructor(public readonly payload) {}
}

export class GET_CHILDSUBMENU_REDIRECTURL {
  public static readonly type = `[${PREFIX}] GET CHILDSUBMENU REDIRECTURL`;
  constructor(public readonly payload) {}
}

export class GET_BRANCH_LIST {
  public static readonly type = `[${PREFIX}] GET BRANCH LIST`;
  constructor(public readonly userId: string) {}
}

export class GET_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET AGENT LIST`;
  constructor(public readonly userId: string) {}
}

export class GET_AGENT_LIST_BY_BRANCH {
  public static readonly type = `[${PREFIX}] GET AGENT LIST BY BRANCH`;
  constructor(
    public readonly userId: string,
    public readonly branchCode: string,
  ) {}
}

export class GET_REFERRED_LIST {
  public static readonly type = `[${PREFIX}] GET REFERRED LIST`;
}

export class GET_MARKETER_MANAGER {
  public static readonly type = `[${PREFIX}] GET MARKETER MANAGER`;
  constructor(public readonly payload) {}
}

export class RESET_MARKETER_AGENT_MANAGER {
  public static readonly type = `[${PREFIX}] RESET MARKETER MANAGER`;
}

export class DOWNLOAD_MOTOR_APPROVAL_REPORT {
  public static readonly type = `[${PREFIX}] DOWNLOAD MOTOR APPROVAL REPORT`;
  constructor(public readonly payload) {}
}

export class RESET_DASHBOARD_SEARCH_RESULT_LIST {
  public static readonly type = `[${PREFIX}] RESET DASHBOARD SEARCH RESULT LIST`;
}

export class GET_ACTIVE_AGENTS_LIST {
  public static readonly type = `[${PREFIX}] GET ACTIVE AGENTS LIST`;
  constructor(public readonly payload) {}
}

export class GET_UNIFIED_LOV_IN_SUMMARY_DASHBOARD {
  public static readonly type = `[DASHBOARD] GET UNIFIED LOV IN SUMMARY DASHBOARD`;
  constructor(public readonly userId: string) {}
}

export class SET_ACITVE_SUMMARY {
  public static readonly type = `[DASHBOARD] SET ACTIVE SUMMARY TAB`;
  constructor(public readonly activeSummary: string) {}
}
